import { SortOrder } from '@app/core/enums/sort-order.enum';

export const SKIP_CONFIRMATION_KEY = 'skip-kpi-selection-confirmation';

export const DEFAULT_CORRELATIONS_SORT_FIELD = 'quality';
export const DEFAULT_CORRELATIONS_SORT_ORDER = SortOrder.Desc;

export const DEFAULT_LOGGER_NOISE_SORT_FIELD = 'leakScore';
export const DEFAULT_LOGGER_NOISE_SORT_ORDER = SortOrder.Desc;

export const DEFAULT_EVENTS_SORT_FIELD = 'created';
export const DEFAULT_EVENTS_SORT_ORDER = SortOrder.Desc;

export const EVENTS_SECONDARY_SORT_FIELDS = ['eventStatusRank'];
export const EVENTS_ALTER_SORT_FIELDS = ['created'];
export const EVENTS_SECONDARY_SORT_ORDER = SortOrder.Desc;

export const CORRELATIONS_SECONDARY_SORT_FIELDS = ['logger1SerialNo', 'logger2SerialNo'];
export const CORRELATIONS_ALTER_SORT_FIELDS = ['soundSignalStartAt'];

export const CORRELATIONS_DISTANCE_FIELDS = ['distanceL1', 'distanceL2'];
export const CORRELATIONS_PIPE_PROVIDED_FIELD = 'pipeProvided';

export const LOGGER_NOISE_SECONDARY_SORT_FIELDS = ['serialNo'];
export const LOGGER_NOISE_ALTER_SORT_FIELDS = ['soundSignalStartAt'];
